import getLocalWishlist from '../../scripts/wishlist/getLocalWishlist';
import removeWishlist from '../../scripts/wishlist/removeWishlist';
import { SELECTORS } from '../../scripts/wishlist/vars';

// Import the slideshow component to ensure it registers on this page
import '../scripts/slideshow';

class WishlistPage extends HTMLElement {
  connectedCallback() {
    this.setupGrid();
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.addEventListener('wishlist:updated', this.setupGrid.bind(this));
  }

  get wishlistGrid() {
    return this.querySelector(SELECTORS.WISHLIST_GRID);
  }

  async setupGrid() {
    if (!this.wishlistGrid) return;
    const wishlist = getLocalWishlist();
    const requests = wishlist.map(this.fetchProductCardHTML);
    const responses = await Promise.all(requests);

    const wishlistProductCards = responses.filter((response) => response !== undefined).join('');
    this.renderWishlistContent(wishlistProductCards);
  }

  renderWishlistContent(wishlistProductCards) {
    const wishlistEmpty = this.querySelector(SELECTORS.WISHLIST_EMPTY);
    const wishlistGridWrapper = this.querySelector(SELECTORS.WISHLIST_GRID_WRAPPER);
    if (wishlistProductCards) {
      if (wishlistEmpty) {
        wishlistEmpty.classList.add('hidden');
      }
      if (wishlistGridWrapper) {
        wishlistGridWrapper.classList.remove('hidden');
      }
      this.wishlistGrid.innerHTML = wishlistProductCards;

      // Explicitly upgrade the newly injected slideshow components
      if (customElements.upgrade) {
        const slideshows = this.wishlistGrid.querySelectorAll('slideshow-component');
        slideshows.forEach((el) => customElements.upgrade(el));
      }
    } else {
      if (wishlistEmpty) {
        wishlistEmpty.classList.remove('hidden');
      }
      if (wishlistGridWrapper) {
        wishlistGridWrapper.classList.add('hidden');
      }
      this.wishlistGrid.innerHTML = '';
    }

    const event = new CustomEvent('wishlist:render-content', {});
    document.dispatchEvent(event);
  }

  async fetchProductCardHTML(handle) {
    const productTileTemplateUrl = `/products/${handle}?view=wishlist-product-card`;
    try {
      const res = await fetch(productTileTemplateUrl);

      if (res.status === 404) {
        removeWishlist(handle);
        return;
      }

      const res_2 = await res.text();
      const text = res_2;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');

      const productCard = htmlDocument.documentElement.querySelector('.product-card.wishlist-version');

      let listElement = null;
      if (productCard) {
        listElement = document.createElement('div');
        listElement.innerHTML = productCard.outerHTML;
      }

      if (listElement) return listElement.outerHTML;
    } catch (err) {
      return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
    }
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage);
}
